import { NodeType } from "./model";
import styles from "./node-panel.module.css";
import { useContext } from "react";
import { GraphContext } from "./data";
import { MolStarWrapper } from "./molstar-component";
import { NodeLabels } from "./node-labels";

export type NotePanelProps = {
  data: { isOpen: boolean; nodes: NodeType[] };
};

export const NotePanel = () => {
  const { nodeData } = useContext(GraphContext);
  // console.log("node props:", nodeData);
  const display = !nodeData || !nodeData["id"] ? "none" : "flex";
  return (
    <div
      className={"side-panel " + styles.panel + " " + styles.panelRight}
      style={{ display }}
    >
      <div className="title">{nodeData && nodeData["id"]}</div>
      <div className="details">
        <MolStarWrapper />
        <NodeLabels node={nodeData} />
      </div>
    </div>
  );
};
